import styled from "styled-components";

import { Box } from "@braze/beacon-core";

export const StyledBoxWrapper = styled(Box).attrs({
  inline: true,
  mr: "md",
})`
  vertical-align: middle;
`;
